import React from "react";
import { useTranslation } from "react-i18next";
import styles from "../../../detail.module.css";
import LineGraph from "../../line_graph/line_graph";

export default function UsageSection() {
    const { t } = useTranslation();

    return (
        <div>
            <LineGraph unit={'KW/h'} min={0} max={10} color={'#4880b8'} secondaryColor={'#4880b8'} entries={[]} valueName={`avg_power`} header={[
                <div className={'d-flex justify-content-between align-items-center px-3 py-3'}>
                    <div className={'d-flex align-items-center'}>
                        <img alt={'thunder'} src={'/icons/purple_thunder.png'} width={'10px'} height={'100%'} className={'me-2'}/>
                        <div className={'d-flex align-items-center'} style={{color: '#1B365D99', fontSize: '12px', fontWeight: 600, whiteSpace: 'nowrap'}}>
                            <div className={'pe-2'}>{t('usage.title')}</div>
                            <div style={{
                                color: '#ED8B00'
                            }}>OUT</div>
                        </div>
                    </div>
                    <div className={'d-flex'}>
                        <div className={styles.frequency}>{t('usage.year')} <div>2024</div></div>
                        <div className={styles.frequency}>{t('usage.month')} <div>{t('usage.february')}</div></div>
                        <div className={styles.frequency}>{t('usage.week')}</div>
                    </div>
                </div>
            ]}/>
        </div>
    )
}